/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export { FocusStyleManager } from "./accessibility/focusStyleManager";
export * from "./common";
export * from "./components";
export * from "./context";
export * from "./hooks";

/* eslint-disable deprecation/deprecation */
export * from "./deprecatedTypeAliases";

export {
    HotkeysTargetLegacy as HotkeysTarget,
    type HotkeysTargetLegacyComponent as IHotkeysTargetComponent,
} from "./legacy/hotkeysTargetLegacy";
export {
    isHotkeysDialogShowing,
    setHotkeysDialogProps,
    showHotkeysDialog,
    hideHotkeysDialog,
    hideHotkeysDialogAfterDelay,
} from "./legacy/hotkeysDialogLegacy";
export { ContextMenuTargetLegacy, type ContextMenuTargetLegacyComponent } from "./legacy/contextMenuTargetLegacy";
